<template>
  <div v-if="this.getCertification && this.getCertification.length > 0">
    <div class="productCertificationWrapper">
      <div class="productCertification">
        <div class="certificate" v-for="(certificate, index) in getCertification" :key="index">
          <img :src="`${certificate.Url}`" :alt="certificate.Name">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'ProductCertification',

  computed: {
    ...mapGetters("prodspecification", ["getCertification"])
  }
};
</script>

<style lang="scss" scoped>
.productCertificationWrapper {
  margin-top: 0px;
  margin-bottom: 0px;
  @include media-breakpoint-up(lg) {
    margin-top: 8px;
    margin-bottom: 10px;
  }
  @include media-breakpoint-up(sm) {
    margin-top: 8px;
    margin-bottom: 10px;
  }
  @include media-breakpoint-up(xs) {
    margin-top: 8px;
    margin-bottom: 10px;
  }
}

.productCertification {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top: 0px;

  @include media-breakpoint-up(xs) {
    margin-top: 0px;
    width: 100%;
  }

  @include media-breakpoint-up(sm) {
    margin-top: 0px;
  }
}
.certificate {
  margin-right: 20px;
  margin-bottom: 10px;
  height: 20px;
  @include media-breakpoint-up(lg) {
    margin-bottom: 10px;
  }
}
.certificate img {
  min-height: 20px;
  max-height: 20px;
}
</style>